<template>
    <!-- 缴费票据 Dialog -->
    <el-dialog v-model="visible" title="缴费票据" width="54%" append-to-body close-on-click-modal="false" class="bill-dialog">
        <!-- 票据内容区域 -->
        <div id="dayin" style="padding: 0.3125rem">
            <div id="dayinxinxi" style="margin: 10px 60px">
                <table class="pure-table pure-table-bordered" style="width: 100%; border-collapse: collapse">
                    <thead>
                        <tr>
                            <th>房间编号</th>
                            <th>房间名称</th>
                            <th>门牌号</th>
                            <th>缴费金额</th>
                            <th>缴费类型</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>17号楼1层101</td>
                            <td>101</td>
                            <td>null</td>
                            <td>49.4</td>
                            <td>退费</td>
                        </tr>
                        <tr>
                            <th>发票编码</th>
                            <th>缴费时间</th>
                            <th>上次余额</th>
                            <th>本次余额</th>
                            <th></th>
                        </tr>
                        <tr>
                            <td>IN2025090019231000002</td>
                            <td>2025-09-08 16:22:51</td>
                            <td>49.4</td>
                            <td>0</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th colspan="5">描述</th>
                        </tr>
                        <tr>
                            <td colspan="5">导入余额重置</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- 打印按钮 -->
            <div style="text-align: center; margin: 20px 0">
                <el-button type="primary" @click="dayins">打印票据</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, defineExpose } from 'vue'

// 控制弹窗显示
const visible = ref(false)

// 打开票据弹窗
const openBillDialog = () => {
    visible.value = true
}
defineExpose({ openBillDialog })

// 打印方法（和你原来的 dayins() 功能一致）
const dayins = () => {
    const printContent = document.getElementById('dayin').innerHTML
    const newWindow = window.open('', '_blank')
    newWindow.document.write(`
    <html>
      <head>
        <style>
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #333; padding: 6px; text-align: center; }
        </style>
      </head>
      <body onload="print();close();">
        ${printContent}
      </body>
    </html>
  `)
    newWindow.document.close()
}
</script>

<style scoped>
/* 表格样式还原 layui 效果 */
:deep(.pure-table) {
    width: 100%;
    border-collapse: collapse;
}
:deep(.pure-table th) {
    background: #f2f2f2;
    font-weight: bold;
    text-align: center;
}
:deep(.pure-table th, .pure-table td) {
    border: 1px solid #e6e6e6;
    padding: 8px 10px;
    text-align: center;
}

/* 弹窗高度自适应 */
:deep(.el-dialog__body) {
    max-height: 54vh;
    overflow-y: auto;
}
table {
    width: 100%;
    border-collapse: collapse;
}
th,
td {
    border: 1px solid #e6e6e6;
    padding: 6px;
    text-align: center;
}
</style>
